import {useState, useEffect} from 'react';
import '../css/App.css';
import {setGlobalToken} from '../helpers/fetch.js';
import EntryList from './entryList.js';
import Login from './login.js';

let keyListeners = [];

function App() {

  const [token, setToken] = useState(null);

  function setTokenAndGlobal (token) {
    setToken(token);
    setGlobalToken(token, () => setToken(null));
  }

  function handleKeyEvent (e) {
    keyListeners.forEach(l => {
      if (l.metaKey === e.metaKey && l.keys.some(key => key === e.key)) {
        l.func();
        e.preventDefault();
      }
    });  
  }

  function matchesKeys (kl, keys, metaKey) {
    return (JSON.stringify(kl.keys) === JSON.stringify(keys) && kl.metaKey === metaKey);
  }

  function clearKeyListeners () {
    keyListeners = [];
  }

  function listenKey (func, keys, metaKey = false) {
    keyListeners = keyListeners.filter(kl => !matchesKeys(kl, keys, metaKey));
    keyListeners.push({
      func,
      keys,
      metaKey,
    });
  }

  useEffect(() => {
    document.addEventListener('keydown', handleKeyEvent);
    return (() => document.removeEventListener('keydown', handleKeyEvent));
  }, []);

  if (!token) {
    return (<Login setToken={setTokenAndGlobal} />);
  }

  return (
    <div className="App">
      <header className="App-header">
        <EntryList listenKey={listenKey} clearKeyListeners={clearKeyListeners} />
      </header>
    </div>
  );
}

export default App;